// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"195":"fd5c9daf","251":"2a2ff116","448":"2a2ff116","832":"6678bffe","853":"2a2ff116","938":"2a2ff116"}[chunkId] + ".css";
};